import { getApp, getApps, initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import { funcion, rpc } from "./datos";

const claveDispositivo = (miembroId) => `avisos_push_miembro_${miembroId}`;

function leerMarca(miembroId) {
  try {
    return localStorage.getItem(claveDispositivo(miembroId)) === "1";
  } catch (e) {
    return false;
  }
}

function guardarMarca(miembroId) {
  try {
    localStorage.setItem(claveDispositivo(miembroId), "1");
  } catch (e) {
    // Sin almacenamiento local solo se pierde el recordatorio visual.
  }
}

// Estado de los avisos en este dispositivo, sin pedir permiso al usuario:
// "activas", "bloqueadas" (el navegador las rechazó), "pendientes" o "no_disponibles".
export function estadoAvisosEnDispositivo(miembroId) {
  if (typeof window === "undefined" || !("Notification" in window)) return "no_disponibles";
  if (Notification.permission === "denied") return "bloqueadas";
  if (Notification.permission === "granted" && miembroId && leerMarca(miembroId)) return "activas";
  return "pendientes";
}

export async function registrarNotificacionesPush(miembroId) {
  if (!miembroId || !(await isSupported()) || !("Notification" in window) || !("serviceWorker" in navigator)) {
    return { habilitado: false, motivo: "Este dispositivo no admite notificaciones push." };
  }

  // Las notificaciones del navegador requieren HTTPS, excepto en localhost.
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") {
    return { habilitado: false, motivo: "Las notificaciones requieren que la aplicación esté publicada con HTTPS." };
  }

  const permiso = await Notification.requestPermission();
  if (permiso !== "granted") {
    return { habilitado: false, motivo: "No autorizaste las notificaciones." };
  }

  const configuracion = await funcion("configuracion-firebase").catch(() => null);
  if (!configuracion?.habilitado) {
    return { habilitado: false, motivo: "Firebase aún no está configurado por la iglesia." };
  }

  const firebaseConfig = {
    apiKey: configuracion.apiKey,
    authDomain: configuracion.authDomain,
    projectId: configuracion.projectId,
    storageBucket: configuracion.storageBucket,
    messagingSenderId: configuracion.messagingSenderId,
    appId: configuracion.appId,
  };
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  const registro = await navigator.serviceWorker.register(
    `/firebase-messaging-sw.js?${new URLSearchParams(firebaseConfig)}`
  );
  const token = await getToken(getMessaging(app), {
    vapidKey: configuracion.vapidKey,
    serviceWorkerRegistration: registro,
  });
  if (!token) return { habilitado: false, motivo: "No se pudo registrar el dispositivo." };

  // Firebase no muestra automáticamente los mensajes recibidos con la app
  // abierta; se crea el aviso del sistema también para ese caso.
  onMessage(getMessaging(app), (payload) => {
    if (Notification.permission !== "granted") return;
    const notificacion = payload.notification || {};
    new Notification(notificacion.title || "Iglesia Mi Casa", {
      body: notificacion.body || "Tienes una nueva notificación.",
      icon: "/logo192.png",
    });
  });

  try {
    await rpc("registrar_dispositivo", { p_token: token });
  } catch (error) {
    return { habilitado: false, motivo: error.message || "No se pudo guardar el dispositivo." };
  }
  guardarMarca(miembroId);
  return { habilitado: true };
}
